import { apiUrl_ } from '../config'
import myAxios from '../myAxios'
import { ITeacherQuestionsReview } from '../../interfaces/IQuiz'

const myBaseUrlDomain = apiUrl_
const assessmentsApiUrl = myBaseUrlDomain + '/assessments/api/v1'
const apiUrlRoot = myBaseUrlDomain + '/courses/v1'

export const getAWSChimeJoinDetails = (courseId: string) => {
  const body = {
    course_id: courseId,
  }
  return myAxios.post(`${apiUrlRoot}/gen/aws-chime/join`, body)
}

export const getDiscussionsList = (courseId: string, topicId?: string) => {
  return myAxios.get(
    `${apiUrlRoot}/gen/discussions/course_id/${courseId}?topic_id=${topicId}`,
  )
}

export const postDiscussionsList = (
  courseId: string,
  discussion: any,
  topicId?: string,
) => {
  const body = {
    discussion: discussion,
    topic_id: topicId,
  }
  return myAxios.post(
    `${apiUrlRoot}/gen/discussions/course_id/${courseId}`,
    body,
  )
}

export const submitAssessmentScore = (
  assessment_result_id: string,
  score: string,
  teacher_comment: string,
  teacher_questions_review: Array<ITeacherQuestionsReview>,
) => {
  const body = {
    assessment_result_id: assessment_result_id,
    score: score,
    teacher_comment: teacher_comment,
    teacher_questions_review: teacher_questions_review,
  }
  return myAxios.put(`${assessmentsApiUrl}/score`, body)
}

export const getTopicAssessmentDetailsFromDatabase = (topicId: string) => {
  return myAxios.get(`${assessmentsApiUrl}/course_contents/${topicId}`)
}

export const viewTopicAssessmentDetailsFromDatabase = (
  assessmentId: string,
) => {
  return myAxios.get(
    `${assessmentsApiUrl}/view-course-assessment/${assessmentId}`,
  )
}

export const submitAssessmentSolution = (
  userId: string,
  assessmentId: string,
  topicId: string,
  results: any,
) => {
  const body = {
    user_id: userId,
    result: results,
    course_content_id: topicId,
  }
  return myAxios.put(
    `${assessmentsApiUrl}/assessments_result/assessments/${assessmentId}`,
    body,
  )
}

export const getTopicSolvedAssessmentResults = (topicId: string) => {
  return myAxios.get(
    `${assessmentsApiUrl}/assessments_result/course_contents/${topicId}`,
  )
}

export const deleteAssessmentResults = (assessmentResultId: string) => {
  return myAxios.delete(
    `${assessmentsApiUrl}/assessments_result/assessments/${assessmentResultId}`,
  )
}
